// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"215":"873920e1","674":"ea98bbe8"}[chunkId] + ".chunk.js";
};